import { render, staticRenderFns } from "./modal-recipient-input-databases.vue?vue&type=template&id=5a820fa2&"
import script from "./modal-recipient-input-databases.vue?vue&type=script&lang=js&"
export * from "./modal-recipient-input-databases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports